import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { MasterService } from "src/app/services/master.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { BankMasterResponseModel } from "src/app/model/BankMasterResponseModel";

@Component({
  selector: "app-secure-bank-master-au",
  templateUrl: "./bank-master-au.component.html",
  styleUrls: ["./bank-master-au.component.scss"],
})
export class BankMasterAUComponent implements OnInit {
  bankMasterKey: number;
  pageMode: string;
  bankMasterModel : BankMasterResponseModel;
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;

  constructor(
    private masterService: MasterService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.bankMasterKey = +params["key"];      
      if(this.bankMasterKey) {
        this.masterService
        .getBankMasterBykey(this.bankMasterKey)
        .subscribe((data: any) => {
          if(data.status === 'SUCCESS') {
            this.bankMasterModel = data;
            this.pageMode = "Edit";
            
            this.form.patchValue({
              ifsc: this.bankMasterModel.ifsc,
              bankName: this.bankMasterModel.bankName,
              branchName: this.bankMasterModel.branchName,
            });
          }
          else {
            this.masterService.errorToast(data?.errorMessage);
          }          
        });
      }
      else {
        this.pageMode = "Add";
      }
    });
      
    this.form = new FormGroup({
      ifsc: new FormControl(null, [Validators.required, Validators.maxLength(11), Validators.minLength(11)]),
      bankName: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      branchName: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
    });
  }

  onSubmit() {
    if (this.form.valid) {
      if(this.pageMode === 'Add') {
        this.save();
      }
      else {
        this.update();
      }
    } 
    else {
      this.isSubmitDisabled = false;
    }
  }

  async save() {
    this.masterService
    .saveBankMaster({
      ifsc: this.form.value.ifsc,
      bankName: this.form.value.bankName,
      branchName: this.form.value.branchName,
    })
    .subscribe((data: any) => {
        if(data.status === 'SUCCESS') {
          this.masterService.successToast("Bank Master saved successfully.");
          this.router.navigate(["/secure", "bank-master", "list"]);
        }
        else {
          this.isSubmitDisabled = false;
          this.masterService.errorToast(data.errorMessage);
        }
      }, error => {
        this.isSubmitDisabled = false;
        console.log(error);
        this.masterService.errorToast(error.error.errorMessage, 5*1000);
      });  
  }

  async update() {
    this.masterService
    .updateBankMaster(this.bankMasterKey, {
      ifsc: this.form.value.ifsc,
      bankName: this.form.value.bankName,
      branchName: this.form.value.branchName,
    }).subscribe((data: any) => {
      if(data.status === 'SUCCESS') {
        this.masterService.successToast("Bank Master saved successfully.");
        this.router.navigate(["/secure", "bank-master", "list"]);
      }
      else {
        this.isSubmitDisabled = false;
        this.masterService.errorToast(data.errorMessage);
      }
    }, error => {
      this.isSubmitDisabled = false;
      console.log(error);
      this.masterService.errorToast(error.error.errorMessage, 5*1000);
    });    
  }

}